import { Grid, Stack, Typography, useTheme } from '@mui/material'
import { styled } from '@mui/material/styles'
import GroboticPng from '../../images/Grobotic png.png'
import GroboticLight from '../../images/Grobotic png-lightmode.png'
import { useLayoutContext } from 'context/LayoutProvider/LayoutProvider'

const LoadingLogo = styled('img')({
  width: 200,
  height: 200,
  borderRadius: '50%',
  opacity: 0.5,
})

const NoDataDefault = ({ defaultMessage = 'No Data Found' }: { defaultMessage: string }) => {
  const theme = useTheme()
  const { pinned } = useLayoutContext()
  return (
    <Grid container>
      <Grid item xs={12}>
        <Stack
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center', // Align items to the top to prevent content from being cut off
            height: pinned ? 'calc(100vh - 185px)' : 'calc(100vh - 122px)', // Ensure the content fits within the viewport
            overflowY: 'auto', // Enable vertical scrolling if needed
            padding: 2, // Add some padding to prevent content from touching edges
          }}
        >
          <Typography sx={{ fontWeight: 'bold', fontSize: 22 }}>{defaultMessage}</Typography>
          <LoadingLogo src={theme.palette.mode === 'dark' ? GroboticPng : GroboticLight} alt="Loading..." />
        </Stack>
      </Grid>
    </Grid>
  )
}
export default NoDataDefault
